'use strict';

export default class Application {
	constructor() {
        (function($) {
            var page = 1;

            $('.nextButton').click(function () {
                var $fs = $(this).parents('fieldset');

                $fs.fadeOut();
                var $fsn = $fs.next();
                $fsn.fadeIn();
                page++;
                progress_bar_update();
                return false;
            });

            $('.prevButton').click(function () {
                var $fs = $(this).parents('fieldset');

                $fs.fadeOut();
                var $fsp = $fs.prev();
                $fsp.fadeIn();
                page--;
                progress_bar_update();
                return false;
            });

            var progress_bar_update = (function () {
                $('.progress-tab').removeClass('active');
                $('#page-0' + page).addClass('active');
            });
        })(jQuery);
    }
}